export default "__VITE_ASSET__CrS2a9BT__"